import {NgModule} from '@angular/core';

import {ImageCardComponent} from './index';
import {IonicModule} from 'ionic-angular';
import {ImageFormService} from "../../services/image-form/image-form-service";
import {ImageUploadService} from "../../services/image-upload/image-upload-service";
import {ContentHeaderModule} from "../content-header/content-header.module";
import {UserAuthenticationService} from "../../../../user/login/services/user-authentication.service";
import {CaptionInputModule} from "../inputs/caption/caption.input.module";

/**
 * Module for the Image Card
 * @class
 */
@NgModule({
  declarations: [ImageCardComponent],
  exports: [ImageCardComponent],
  imports: [
    IonicModule,
    ContentHeaderModule,
    CaptionInputModule,
  ],
  providers: [
    ImageUploadService,
    ImageFormService,
    UserAuthenticationService,
  ],
})
export class ImageCardModule {
}



// WEBPACK FOOTER //
// ./src/app/content/shared/components/image-card/image-card.module.ts